import type { FacetConfig } from '../../../shared/components/FacetedFilterRail';
import type { ActionLogEntry } from '../../../types/backend';
import {
  opsItemKind, severityMeta, statusLabel, KIND_META, KindIcon,
  SEVERITY_ORDER, SEVERITY_LABEL, STATUS_ORDER, type OpsItemKind,
} from './opsitemDisplay';

export function matchOpsItemSearch(e: ActionLogEntry, q: string): boolean {
  const needle = q.toLowerCase();
  return (
    e.title.toLowerCase().includes(needle) ||
    (e.rule_name ?? '').toLowerCase().includes(needle) ||
    (e.source ?? '').toLowerCase().includes(needle) ||
    (e.detail_type ?? '').toLowerCase().includes(needle) ||
    (e.automation_result?.result_summary ?? '').toLowerCase().includes(needle)
  );
}

export const OPSITEM_FACETS: FacetConfig<ActionLogEntry>[] = [
  {
    key: 'kinds', title: 'Kind', keyOf: opsItemKind,
    order: Object.keys(KIND_META),
    labelOf: (k) => KIND_META[k as OpsItemKind]?.label ?? k,
    iconOf: (k) => <KindIcon kind={k as OpsItemKind} size={15} />,
  },
  {
    key: 'severities', title: 'Severity', keyOf: (e) => severityMeta(e.severity).level,
    order: SEVERITY_ORDER, labelOf: (k) => SEVERITY_LABEL[k as keyof typeof SEVERITY_LABEL] ?? k,
  },
  {
    key: 'statuses', title: 'Status', keyOf: (e) => e.status,
    order: STATUS_ORDER, labelOf: statusLabel,
  },
  { key: 'rules', title: 'Rule', keyOf: (e) => e.rule_name ?? '', advanced: true },
  { key: 'sources', title: 'Source', keyOf: (e) => e.source ?? '', advanced: true },
];
